import { render, staticRenderFns } from "./ApiIntegration.vue?vue&type=template&id=a282ede0&scoped=true&"
import script from "./ApiIntegration.vue?vue&type=script&lang=js&"
export * from "./ApiIntegration.vue?vue&type=script&lang=js&"
import style0 from "./ApiIntegration.vue?vue&type=style&index=0&id=a282ede0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a282ede0",
  null
  
)

export default component.exports